import axios from 'axios'
import qs from 'qs'
axios.defaults.withCredentials = false;
const service = axios.create({
  baseURL: process.env.BASE_URL_ERP,
})
service.interceptors.request.use(
    config => {
        if(config.method === 'post'){
            config.data = qs.stringify(config.data)
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
service.interceptors.response.use(
    response => response.data,
    error => {
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/require_nocredentials.js